<!--管理中心-->
<template>
    <div class="container">
        <homeHead ref="homeHead" />
        <div class="er-page">
            <!--标签页：课题引领/教研赛事/专题活动/档案管理/教学分析报告-->
            <div class="tab-row">
                <home-manager-menu :item-num="this.activeItem"
                                   @change-item="changeItem"/>
            </div>
            <div class="module-content">
                <!--课题引领-->
                <topic-manager v-if="activeItem==='1'"
                               :item-mode="this.activeMode"
                               @change-mode="changeMode"/>
                <!--档案管理-->
                <archive-manager v-if="activeItem==='2'"
                                 :item-mode="this.activeMode"
                                 @change-mode="changeMode"/>
                <!--教研赛事-->
                <race-manager v-if="activeItem==='3'"
                              :item-mode="this.activeMode"
                              @change-mode="changeMode"/>
                <!--专题活动-->
                <activity-manager v-if="activeItem==='4'"
                                  :item-mode="this.activeMode"
                                  @change-mode="changeMode"/>
                <!--教学分析报告-->
                <user-analyse-report v-if="activeItem==='5'"
                                     :item-mode="this.activeMode"
                                     @change-mode="changeMode"/>
            </div>
        </div>
    </div>
</template>
<script>
import {timestampToTime} from "@/utils/date";
import homeHead from "@/components/homeHead";
import homeManagerMenu from "@/components/homeManager/homeManagerMenu.vue";
import topicManager from "@/components/homeManager/topicManager.vue";
import archiveManager from "@/components/homeManager/archive/archiveManager.vue";
import raceManager from "@/components/homeManager/race/raceManager.vue";
import ActivityManager from "@/components/homeManager/activity/activityManager.vue";
import userAnalyseReport from "@/components/homeManager/report/userAnalyseReport.vue";
export default {
    components: {
        ActivityManager,
        archiveManager,
        homeHead,
        homeManagerMenu,
        topicManager,
        raceManager,
        userAnalyseReport
    },
    name: "homeManagerCenter",
    data() {
        return {
            pageMode:"list",
            detailMode:"detail",
            timestampToTime,
            activePath: "homeManagerCenter",
            activeItem:"1",
            activeMode:"list",
        }
    },
    computed: {},
    watch: {},
    created() {
    },
    mounted() {
        this.$refs.homeHead.activePath = this.activePath;
        if (this.$store.state.params.jumpParams.activeItem){
            this.activeItem = this.$store.state.params.jumpParams.activeItem;
        }
    },
    methods: {
        changeItem(item){
            this.activeItem = item;
            this.activeMode = this.pageMode;
        },
        changeMode(mode){
            this.activeMode = mode;
        }
    }
}
</script>
<style lang="scss" scoped>
.container {
    width: 100%;
    height: 100vh;
    margin: 0;
    overflow-y: auto;
    overflow-x: hidden;
}
.er-page {
    min-height: 100vh;
    box-sizing: border-box;
    padding: 100px 40px 20px;
    background: url("../../assets/screen/homeBg.png") no-repeat center center;
    background-size: cover;
}
/*标签页*/
.tab-row {
    display: flex;
    align-items: center;
    gap: 16px;
    max-width: 1840px;
    margin: 0 auto 24px;
}
.module-content {
    max-width: 1840px;
    margin: 0 auto;
    min-height: calc(100vh - 182px);
    box-sizing: border-box;
}
</style>